//router
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

//component
import Echrontech from "./screen/Echrontech";
import Home from "./screen/Home";
import Page from "./screen/Page";
import Error from "./screen/Error";
import Search from "./Search";
import DataFilter from "./Filter/DataFilter";
import Contact from "./screen/Contact";
import About from "./screen/About";
import TermsConditions from "./screen/TermsConditions";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Echrontech />}>
            <Route path="/search" element={<Search />}></Route>
            {/* <Route path="/datafilter" element={<DataFilter />}></Route> */}
            <Route path="/search/:data" element={<Search />}></Route>
            <Route index element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<TermsConditions />} />
            <Route path="/disclaimer" element={<TermsConditions />} />

            <Route path="404" element={<Error />} />
            <Route path="*" element={<Page />} />
          </Route>
          <Route
            path="/haryana/gurgaon/nh-8/vatika-business-park"
            element={
              <Navigate
                to="/haryana/gurgaon/sohna-road/vatika-business-park"
                replace
              />
            }
          />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
